<div class="d-flex justify-content-between align-items-center mb-3">
  <h1 class="fs-5 fw-bold mb-0">Offers</h1>
  <div class="d-flex gap-2">
    <a [routerLink]="['add']" *isGranted="['ROLE_API_OFFER_WRITE']" class="btn btn-primary fw-bold"><i
    class="bi bi-plus-lg me-2"></i>Add Offer
  </a>
</div>
</div>

<div class="card border-0 shadow mb-3 fade-in-zoom">
  <div class="card-body">

    <div class="d-flex gap-3 align-items-center mb-3">
      <app-dropdown-select [multiple]="true" [(ngModel)]="filters.values['products']" placeholder="Filter by product"
        (onDropdownChange)="filters.onFilterChange()" class="form-control">
        @for (product of products; track product.id) {
          <app-dropdown-select-option [value]="product.id">{{ product }}</app-dropdown-select-option>
        }
      </app-dropdown-select>

      <app-dropdown-select [multiple]="true" [(ngModel)]="filters.values['conversionTypes']" placeholder="Filter by type"
        (onDropdownChange)="filters.onFilterChange()" class="form-control">
        @for (conversionType of conversionTypeList; track conversionType) {
          <app-dropdown-select-option
            [value]="conversionType">{{ ('conversionType.' + conversionType) | translate }}
          </app-dropdown-select-option>
        }
      </app-dropdown-select>

      <app-dropdown-select [multiple]="true" [(ngModel)]="filters.values['countries']" placeholder="Filter by lang"
        (onDropdownChange)="filters.onFilterChange()" class="form-control">
        @for (country of countries; track country.isoCode) {
          <app-dropdown-select-option [value]="country.isoCode">
            <img [ngSrc]="countryService.getFlag(country.isoCode)" [alt]="country.name" class="country-flag"
              width="24" height="24">
            {{ country.name }}
          </app-dropdown-select-option>
        }
      </app-dropdown-select>

      <app-dropdown-select [multiple]="true" [(ngModel)]="filters.values['accountTypes']"
        placeholder="Filter by account type" (onDropdownChange)="filters.onFilterChange()" class="form-control">
        @for (accountType of partnerAccountTypeList; track accountType) {
          <app-dropdown-select-option [value]="accountType">
            {{ 'partnerAccountType.' + accountType | translate }}
          </app-dropdown-select-option>
        }
      </app-dropdown-select>

      <button type="button" class="btn btn-outline-primary ms-2" (click)="filters.saveFilters()" title="Save filters">
        <i class="bi bi-floppy"></i>
      </button>
      <button type="button" class="btn btn-outline-secondary ms-2" (click)="filters.clearFilters()" title="Clear filters">
        <i class="bi bi-eraser"></i>
      </button>
    </div>

    <!-- Table of users -->
    <div class="table-responsive mt-5">
      <table class="table table-hover table-striped align-middle">
        <thead>
          <tr [tableSorter]="tableSorter" (tableSorterChange)="refresh()">
            <th tableSorterHeader="id">ID</th>
            <th tableSorterHeader="name">Name</th>
            <th tableSorterHeader="product">Parent Brand</th>
            <th tableSorterHeader="advertiser">Advertiser</th>
            <th tableSorterHeader="conversionType">Type</th>
            <th tableSorterHeader="conversionType">Target</th>
            <th>GEO</th>
            <th>Pre-Approval</th>
            <th>Payout</th>
            <th tableSorterHeader="enabled">Status</th>
            <th class="text-center">Action</th>
          </tr>
        </thead>
        <tbody>
          @for (offer of offers; track offer) {
            <tr>
              <td>{{ offer.id }}</td>
              <td>{{ offer.name }}</td>
              <td>{{ offer.product }}</td>
              <td>{{ offer.product?.advertiser }}</td>
              <td>
                @if (offer.conversionType) {
                  {{ ('conversionType.' + offer.conversionType) | translate }}
                }
              </td>
              <td>
                @if (offer.targetAccountType) {
                  {{ ('partnerAccountType.' + offer.targetAccountType) | translate }}
                }
                @if (!offer.targetAccountType) {
                  All
                }
              </td>
              <td>
                <app-collapser>
                  @for (country of offer.countries; track country) {
                    <app-collapser-item>
                      <img [ngSrc]="countryService.getFlag(country)" [alt]="country" width="24" height="24" class="me-1">
                    </app-collapser-item>
                  }
                </app-collapser>
              </td>
              <td>{{ offer.requireApproval ? 'Yes' : 'No' }}</td>
              <td>
                @if (offer.hasMultiplePayouts()) {
                  Multiple payouts
                }
                @if (!offer.hasMultiplePayouts()) {
                  {{ offer.getRegistrationPayout() | currency: 2:$safeNavigationMigration(offer.currency?.isoCode) }}
                }
              </td>
              <td>
                @if (offer.enabled) {
                  <span class="badge bg-success">Enabled</span>
                }
                @if (!offer.enabled) {
                  <span class="badge bg-danger">Disabled</span>
                }
              </td>
              <td class="text-center">
                <a class="btn btn-outline-primary btn-sm" [routerLink]="[offer.id]"><i class="bi bi-pencil me-1"></i>Edit
              </a>
              <button *isGranted="['ROLE_API_OFFER_WRITE']" class="btn btn-outline-danger btn-sm ms-1" appConfirm
                (click)="delete(offer)"><i
              class="bi bi-trash"></i></button>
            </td>
          </tr>
        }
      </tbody>
    </table>

    <app-paginator (pageChange)="refresh()" [paginator]="paginator"></app-paginator>
  </div>
</div>
</div>
